<template>

<div v-if='isReady' class="row mt-2">

    <div v-if='$store.state.isOwner && $parent.phase.code == "rp"' class="col-12">
        <div class='alert alert-info'>
            Ако желате можете да се самоназначите за изпълнител на този етап
        </div>
        <button @click='selfAssign' class='btn btn-info' :disabled='isLoading'>
            Вие ще изпълнявате ролята на ръководител.
        </button>
    </div>

    <div class="col-12">
        <div class="auction-item auction-loading list-item shadow text-center d-flex justify-content-center align-items-center pt-5 pb-5 pl-4 pr-4 mb-3">
            <div>
                <div class="text" v-if='$parent.phase.type == "competition"'>
                    <h4 class="mb-0">
                        До момента {{ numOffers }} {{ numOffers == 1 ? 'дизайнер е заявил' : 'дизайнери са заявили' }} участие в конкурса.
                    </h4>
                    <span v-if="numOffers != 0">
                        {{ numOffers == 1 ? 'Той' : 'Всеки от тях' }} трябва да предаде своето идейно предложение до края срока на конкурса. <br>
                        Тук ще се подредят проектите, при което ще може да ги разгледате и изберете проекта, което Ви допада най-много.
                    </span>

                    <!-- <div>
                        <h5>Суми за заплащане</h5>
                        <p>Цяла сума {{ $store.state.ip.detiled.total }} лв.</p>
                        <p>Такса видеа {{ $store.state.ip.detiled.tax }} лв.</p>
                        <p>След такса {{ $store.state.ip.detiled.afterTax }} лв.</p>
                        <p>Първо място {{ $store.state.ip.detiled.first_place }} лв.</p>
                        <p>Второ място {{ $store.state.ip.detiled.second_place }} лв.</p>
                        <p>Трето място {{ $store.state.ip.detiled.third_place }} лв.</p>
                    </div> -->
                </div>

                <div class="text mt-4" v-else>
                    <h4 class="mb-0">
                        До момента сте получили {{ numOffers }} {{ numOffers == 1 ? 'офертa' : 'оферти' }}.
                    </h4>
                    <span v-if="numOffers != 0">
                        {{ numOffers == 1 ? 'Ще можете да я' : 'Ще можете да ги' }} видите след изтичане на срока на търга.
                        Тук ще се подредят офертите, подредени спрямо процентното съотношение на параметрите (цена, срок и рейтинг), които сте настоили в заданието.
                    </span>
                </div>
   
                <phase-timer :end='$parent.projectPhase.end_date' :msg='timerMessage'></phase-timer>
            </div>
        </div>
    </div>

    <div v-if='!isReady' class="d-flex justify-content-center">
        <img src='/resources/loader.svg'>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                timerMessage : 'Времето е изтекло',
                numOffers : 0,
                isLoading : false
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('phs:gof', { pp : this.$parent.projectPhase.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.numOffers = r.data;
                    }

                    me.isReady = true;

                })

            },

            selfAssign() {

                if( !confirm("Сигурни ли сте че искате да се самоназначите за ръководител на проекта?") ) {
                    return;
                }

                var me = this;

                this.isLoading = true;
                
                me.ajax.call('phs:sfas', { pp : this.$parent.projectPhase.id }, (r) => {
                    
                    this.isLoading = false;

                    if( r.status == 'success' ) {
                        location.reload();
                    }

                })
            }

        }

    }
</script>
